import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;
`;

export const Content = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Illustration = Styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 26.25rem;
  border-radius: 1.25rem;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    height: 43.75rem;
  }
`;
